import { type GridPosition } from '../../machine/state/types';

export type ClickTarget = { type: 'cell'; position: GridPosition } | { type: 'none' };

export function getClickTarget(x: number, y: number): ClickTarget {
  const el = document.elementFromPoint(x, y);
  if (!el) {
    return { type: 'none' };
  }

  //TODO add row and col logic

  const cellEl = el.closest('[data-entry-id][data-field-id]');
  if (cellEl) {
    const entryId = cellEl.getAttribute('data-entry-id');
    const fieldId = cellEl.getAttribute('data-field-id');
    const rowIndex = cellEl.getAttribute('data-row-index');
    const colIndex = cellEl.getAttribute('data-col-index');

    if (entryId && fieldId && rowIndex && colIndex) {
      return {
        type: 'cell',
        position: {
          row: { id: entryId, index: parseInt(rowIndex, 10) },
          col: { id: fieldId, index: parseInt(colIndex, 10) },
        },
      };
    }
  }

  return { type: 'none' };
}
